(function loginControllerDefinition() {
    'use strict';

    angular.module('LoginPage')
        .controller('LoginPageController', [
            '$scope', 'config', '$state', '$stateParams', 'authExtend', 
            function loginPageController($scope, config, $state, $stateParams, auth) {
                if (auth.isLogged()) {
                    $state.go('inicio');
                }

                $scope.showForm = true;
                if ($stateParams.confirmed) {
                    $scope.showConfirmed = true;
                }
                $scope.loginResult = function (result) {
                    return result;
                };
            }
        ]);
})();